import * as React from 'react';
import bindAllOfThis from "src/utils/BindThisHelper"; // 'this' binder
import { Translate, LocalizeContextProps, withLocalize } from 'react-localize-redux';
import "./GalaxyGuidePage.less";
import { PageProps } from 'src/models/common/ComponentProps';

interface HollandAreasGuideProps extends PageProps<{}>, LocalizeContextProps {
}

class HollandAreasGuide extends React.Component<HollandAreasGuideProps> {
    constructor(props: HollandAreasGuideProps) {
        super(props);
        bindAllOfThis(this, HollandAreasGuide.prototype);
    }

    private renderSections() {
        var sections = [];

        for (var i = 1; i <= 6; i++) {
            var section = <div>
                <h3><Translate id={`public.guide.hollandAreas.section${i}.header`} /></h3>
                <p><Translate id={`public.guide.hollandAreas.section${i}.para1`} /></p>
                <p><Translate id={`public.guide.hollandAreas.section${i}.para2`} /></p>
            </div>;
            sections.push(section);
        }

        return sections;
    }

    render() {
        return <div className="galaxy-guide">
            <h2><Translate id="public.guide.hollandAreas.header" /></h2>
            <p><Translate id="public.guide.hollandAreas.intro1" /></p>
            <p><Translate id="public.guide.hollandAreas.intro2" /></p>
            <p><Translate id="public.guide.hollandAreas.intro3" /></p>
            <img className="hollandCodes" src={require("src/assets/qci/sprites/hollandCodes.png")}></img>
            <h3><Translate id="public.guide.hollandAreas.subheader1" /></h3>
            {this.renderSections()}
            <h3><Translate id="public.guide.hollandAreas.subheader2" /></h3>
            <p><Translate id="public.guide.hollandAreas.conclusion1" /></p>
            <p><Translate id="public.guide.hollandAreas.conclusion2" /></p>
        </div>;
    }
}

export default withLocalize(HollandAreasGuide);



// WEBPACK FOOTER //
// ./src/pages/public/HollandAreasGuide.tsx